// @flow
import { OFFERS_GRID } from 'Client/cms/toolkit/constants';
import { OffersGridLine } from 'Components/lines/offers-grid-line/OffersGridLine.jsx';
import { offersGridResolver } from './offersGrid.resolver';

export const offersGridDescriptor = {
  name: OFFERS_GRID,
  component: OffersGridLine,
  resolve: offersGridResolver.resolve,
};
